function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4866 13L9.15329 3.66665C9.037 3.46146 8.86836 3.29078 8.66457 3.17203C8.46078 3.05329 8.22915 2.99072 7.99329 2.99072C7.75743 2.99072 7.52579 3.05329 7.322 3.17203C7.11822 3.29078 6.94958 3.46146 6.83329 3.66665L1.49995 13C1.38241 13.2036 1.32077 13.4346 1.32129 13.6697C1.32181 13.9047 1.38447 14.1355 1.50292 14.3385C1.62136 14.5416 1.79138 14.7097 1.99575 14.8259C2.20011 14.942 2.43156 15.0021 2.66662 15H13.3333C13.5672 14.9997 13.797 14.938 13.9995 14.8208C14.202 14.7037 14.3701 14.5354 14.487 14.3327C14.6038 14.1301 14.6653 13.9002 14.6653 13.6663C14.6652 13.4324 14.6036 13.2026 14.4866 13Z",
  stroke: "black",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 7V9.66667",
  stroke: "black",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.3333H8.00667",
  stroke: "black",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCourseWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseWarningIcon);
export default __webpack_public_path__ + "static/media/course-warning-icon.0d61cfd5.svg";
export { ForwardRef as ReactComponent };